
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanNorth as ObiBuoyCanNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-north.js';
 
 
 

 
 export const ObiBuoyCanNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-can-north',
   elementClass: ObiBuoyCanNorthElement,
   events: {
     
   }
  });
 
 